<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import VueApexCharts from "vue3-apexcharts";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";



export default {
  page: {
    title: "Laporan Kegiatan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      title: "Laporan Kegiatan",

      chartOptions: {
        chart: {
          id: 'basic-bar'
        },
        toolbar: {
          show: false // This hides the download buttons
        },
        xaxis: {
          categories: ['January', 'February', 'March', 'April', 'March', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        }
      },
      chartSeries: [{
        name: 'Result',
        data: [40, 20, 12, 40, 20, 12, 40, 20, 12, 40, 20, 12]
      }]
    };
  },
  mounted() {

  },
  methods: {
  },
};
</script>
<style></style>
<template>
  <Layout>
    <PageHeader :title="title" />

    <apexchart type="bar" :options="chartOptions" :series="chartSeries" width="100%" height="350">
    </apexchart>
  </Layout>
</template>
